import { Theme, styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import { designTokens } from '@design-system';

import { drawerWidth } from '../../AppConfig';

interface AppBarStyledProps {
  theme: Theme;
  open: boolean;
}

const AppBarStyled = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarStyledProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: `linear-gradient(135deg, ${designTokens.colors.background.dark} 0%, ${designTokens.colors.background.darkPaper} 100%)`,
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.14)',
  borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
  backdropFilter: 'blur(10px)',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    [theme.breakpoints.up('lg')]: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default AppBarStyled;
